<template>
  <EmptyListingBlock
    class="podcasts-block__empty container"
    title="Podcasts"
    :useDefaultImage="true"
  >
    <h3>No podcasts found for "{{ term }}"</h3>
    <p>
      Try a different search, or email us a list of podcasts you want us to
      cover!
    </p>
    <router-link
      :to="{ name: 'help' }"
      class="btns btns--font-medium btns--white"
      >Request podcasts</router-link
    >
  </EmptyListingBlock>
</template>

<script setup lang="ts">
import type { PodcastsView } from '@/models/docs.list.podcasts'
import EmptyListingBlock from '@/app/components/listing/EmptyListingBlock.vue'

defineProps<{
  view: PodcastsView
  term: string
}>()
</script>
